import datapoints from '../datapoints';
import Module from 'mini-common-schema/lib/schema/Module';
import { logUsage } from 'owa-analytics';
import { onModuleClick } from '../actions/onModuleClick';
import { setNavigationStart } from 'mini-performance/lib/utils/getTimeFromFetchStart';

/**
 * onClick handler for module switcher items
 * @param currentModule current app
 * @param selectedModule selected app
 * @param onActiveModuleClickAction special handler when both current and selected app are same
 */
export default function onModuleSwitcherItemClick(
    currentModule: Module,
    selectedModule: Module,
    onActiveModuleClickAction: () => void
): void {
    if (currentModule === selectedModule) {
        onActiveModuleClickAction && onActiveModuleClickAction();
        return;
    }

    const { eventName, customData } = datapoints.ModuleSwitch.datapoint;
    logUsage(eventName, customData(currentModule.toString(), selectedModule.toString()));

    // set the navigation start marker
    setNavigationStart(performance.now());

    onModuleClick(selectedModule, currentModule);
}
